import React, { useContext } from "react";

import Icon from "../../atoms/Icon";
import SectionWrapper from "../../SectionWrapper";
import UserContext from "../../../context/user/userContext";
import { currencies, languages } from "../../../utils/helpers";

import {
  Text,
  Info,
  InfoDiv,
  DropDown,
  Container,
  StyledOption,
  DropDownSelect,
} from "./SubNav.styles";

const SubNav = () => {
  const {
    user: { email, phone, currency, language },
    setCurrency,
    setLanguage,
  } = useContext(UserContext);

  return (
    <SectionWrapper bgColor="#7e33e0" padding="10px 0">
      <Container>
        <InfoDiv>
          <Info>
            <Icon src="/svgs/email.svg" alt="email" width={14} height={14} />

            <Text>{email}</Text>
          </Info>
          <Info>
            <Icon src="/svgs/phone.svg" alt="phone" width={14} height={14} />

            <Text>{phone}</Text>
          </Info>
        </InfoDiv>

        <InfoDiv>
          <DropDown htmlFor="language" width={60}>
            <DropDownSelect
              name="language"
              defaultValue={language}
              onChange={e => setLanguage(e.target.value)}
            >
              {languages.map((language, idx) => (
                <StyledOption key={idx} value={language}>
                  {language}
                </StyledOption>
              ))}
            </DropDownSelect>
          </DropDown>

          <DropDown htmlFor="currency" width={45}>
            <DropDownSelect
              name="currency"
              defaultValue={currency}
              onChange={e => setCurrency(e.target.value)}
            >
              {currencies.map((currency, idx) => (
                <StyledOption key={idx} value={currency}>
                  {currency}
                </StyledOption>
              ))}
            </DropDownSelect>
          </DropDown>

          <Info>
            <Text>Login</Text>

            <Icon src="/svgs/user.svg" alt="user" width={14} height={14} />
          </Info>
          <Info>
            <Text>WishList</Text>

            <Icon src="/svgs/heart.svg" alt="heart" width={14} height={14} />
          </Info>

          <Icon src="/svgs/cart.svg" alt="cart" width={16} height={16} />
        </InfoDiv>
      </Container>
    </SectionWrapper>
  );
};

export default SubNav;
